
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { WorldCountry } from '@/data/countries/types';

interface CountryCitiesGridProps {
  country: WorldCountry;
}

const CountryCitiesGrid = ({ country }: CountryCitiesGridProps) => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold text-brand-gray-900 mb-6">
          Browse Best Psychotherapists by City in {country.name}
        </h2>
        <p className="text-brand-gray-700 mb-8">
          Select your city below to find the best psychotherapists in {country.name} near you. 
          Each city page features qualified mental health professionals who are available for 
          both in-person and online therapy sessions.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {country.topCities.map((city) => {
            // Limpiar el nombre de la ciudad de cualquier número al final
            const cleanCityName = city.name.replace(/\s+\d+$/, '').trim();
            
            return (
              <Link 
                key={city.slug}
                to={`/city/${city.slug}`} 
                className="bg-white rounded-lg shadow-sm border border-brand-gray-200 p-4 hover:shadow-md transition-all duration-300 flex items-center"
                aria-label={`Find the best psychotherapists in ${cleanCityName}, ${country.name}`}
              >
                <MapPin className="h-4 w-4 text-brand-blue-500 mr-2 flex-shrink-0" />
                <span className="text-brand-gray-800 font-medium">Best Psychotherapists in {cleanCityName}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CountryCitiesGrid;
